import React from 'react';

import '../css/about.css';

import jamiePortrait from '../img/jamie-sparker-portrait.png';

function About() {
  return (
    <section id='about'>
      <div className='text-container'>
        <h3>About Me</h3>
        <p>
          Let me tell you a little something about myself. I am an actor,
          director and a model who is not afraid of taking on new challenging
          opportunities. My dream is to become a Hollywood actor one day and
          show the world what I am able to achieve. I have the patience and
          motivation which allows me to strive for my goals.
        </p>
      </div>
      <img src={jamiePortrait} alt='' />
    </section>
  );
}

export default About;
